export const ERROR_BAD_REQUEST = 'BAD_REQUEST'
export const ERROR_NOT_ALLOWED = 'ERROR_NOT_ALLOWED'
export const ERROR_NOT_FOUND = 'ERROR_NOT_FOUND'

export const STATUS_CODES: Record<string, number> = {
  [ERROR_BAD_REQUEST]: 400,
  [ERROR_NOT_ALLOWED]: 403,
  [ERROR_NOT_FOUND]: 404,
}

export class ErrorBadRequest extends Error {
  constructor(message: string) {
    super(message)
    this.name = ERROR_BAD_REQUEST
  }
}

export class ErrorNotAllowed extends Error {
  constructor(message: string) {
    super(message)
    this.name = ERROR_NOT_ALLOWED
  }
}

export class ErrorNotFound extends Error {
  constructor(message: string) {
    super(message)
    this.name = ERROR_NOT_FOUND
  }
}